/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import { SelectControl, ToggleControl, PanelBody } from '@wordpress/components';

/**
 * Styles
 */
import './editor.scss';

/**
 * Edit function for Summary Block
 */
export default function Edit({ attributes, setAttributes }) {
    const blockProps = useBlockProps();

    return (
        <div {...blockProps}>
            <div className="jvb-summary-preview">
                <h3>{__('Summary', 'jvb')}</h3>
                <p className="jvb-list-preview-note">
                    {__('This will inherit the current query to build the information from our custom meta on the front end.', 'jvb')}
                </p>
            </div>
        </div>
    );
}
